"use client";

import { Droplet, Leaf, Sun } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Sustainability() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const grid = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const pillars = [{
    icon: Leaf,
    eyebrow: "01",
    title: "Eficiência Industrial",
    body: "Otimizamos processos para reduzir desperdícios em 35%, garantindo uma produção mais limpa e alinhada com as normas ambientais vigentes."
  }, {
    icon: Sun,
    eyebrow: "02",
    title: "Gestão Energética",
    body: "Implementamos sistemas de controlo que reduzem o consumo energético em 40%, promovendo operações sustentáveis e de alto desempenho."
  }, {
    icon: Droplet,
    eyebrow: "03",
    title: "Uso de Recursos",
    body: "Tecnologias de pulverização de precisão que minimizam o consumo de água e químicos, protegendo os recursos naturais em cada aplicação."
  }];
  return <section data-section-id="8267" id="complianceandmetrics" className="bg-background py-32 md:py-44 text-foreground">
      <div className="mx-auto w-full max-w-[1440px] px-6 md:px-12 lg:px-[72px]">
        <div ref={header.ref} className="mx-auto max-w-3xl text-center transition-all duration-[900ms]" style={{
        transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)",
        opacity: header.isVisible ? 1 : 0,
        transform: header.isVisible ? "translateY(0)" : "translateY(12px)"
      }}>
          <p className="font-sans text-[11px] font-medium uppercase text-muted-foreground" style={{
          letterSpacing: "0.22em",
          lineHeight: 1
        }}>
            Sustentabilidade
          </p>
          <h2 className="mt-6 font-serif font-normal text-foreground" style={{
          fontSize: "clamp(2rem, 3.6vw, 3.25rem)",
          letterSpacing: "-0.014em",
          lineHeight: 1.08
        }}>
            Compromisso com a{" "}
            <em className="font-serif not-italic italic" style={{
            color: "var(--chart-3)"
          }}>
              inovação
            </em>{" "}
            responsável.
          </h2>
        </div>

        <div ref={grid.ref} className="mt-16 grid grid-cols-1 gap-6 md:mt-20 md:grid-cols-3 md:gap-8">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <div key={i} data-index={i} className="group flex min-h-[420px] flex-col bg-card p-10 transition-all duration-[280ms] ease-out hover:bg-accent md:p-14" style={{
            opacity: grid.isVisible ? 1 : 0,
            transform: grid.isVisible ? "translateY(0)" : "translateY(12px)",
            transition: "opacity 900ms cubic-bezier(0.22, 0.61, 0.36, 1), transform 900ms cubic-bezier(0.22, 0.61, 0.36, 1), background-color 280ms ease-out",
            transitionDelay: grid.isVisible ? `${i * 90}ms` : "0ms"
          }}>
                <Icon className="text-primary" size={28} strokeWidth={1} aria-hidden="true" />
                <div className="mt-12">
                  <p className="font-sans text-[11px] font-medium uppercase text-muted-foreground" style={{
                letterSpacing: "0.22em",
                lineHeight: 1
              }}>
                    {pillar.eyebrow}
                  </p>
                  <h3 className="mt-4 font-serif font-normal text-foreground" style={{
                fontSize: "clamp(1.375rem, 1.9vw, 1.75rem)",
                letterSpacing: "-0.008em",
                lineHeight: 1.18
              }}>
                    {pillar.title}
                  </h3>
                  <p className="mt-4 font-sans text-[15px] font-normal text-muted-foreground" style={{
                letterSpacing: "0",
                lineHeight: 1.62
              }}>
                    {pillar.body}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}